import { render, staticRenderFns } from "./ShopReborn.vue?vue&type=template&id=7b2466b1&scoped=true&"
import script from "./ShopReborn.vue?vue&type=script&lang=ts&"
export * from "./ShopReborn.vue?vue&type=script&lang=ts&"
import style0 from "./ShopReborn.vue?vue&type=style&index=0&id=7b2466b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2466b1",
  null
  
)

export default component.exports